import { MutationHookOptions, useMutation } from '@apollo/client';

import { CREATE_CONSULTATION } from './mutations';

export const useCreateConsultation = (options?: MutationHookOptions) => useMutation(CREATE_CONSULTATION, options);
